import BaseVue from '@/base/BaseVue';
import {Options} from 'vue-class-component';
import HttpBase from '@/http/base/HttpBase';


// @ts-ignore
@Options({
  computed: {
    HttpBase() {
      return HttpBase
    }
  }
})
export default class Jingdian extends BaseVue {

  list: any = {
    list: [],
    pageNum: 0,
    pageSize: 0,
    pages: 0,
    size: 0,
    total: 0,
  };

  search: any = {
    title: null,
    deleted: null,
    pi: 1,
    ps: 10
  };

  mounted() {
    this.getList(1);
  }

  gotoImg(img: string) {
    window.open(img)
  }

  getList(pi: number) {
    this.search.pi = pi;
    console.log(this.search);
    this.http.getJingDianList(this.search).then(res => {
      this.list = res.data;
      this.list.list.forEach((item:any)=>{
        if(item.type!=0){
          item.src=`${HttpBase.getRootUrl()}/login/wx/getMiniQRcode/app?pagePath=pages/index/index&width=500&scene=${item.id}`
        }
      })
    }).catch(res => {
      console.log(res)
      this.toast_warn(res.msg);
    });
  }

  onReset() {
    this.search = {
      name: null,
      pi: 1,
      ps: 10
    };
    this.getList(1);
  }

  deleted(item: any) {
    this.http.deletedJingDian({id: item.id}).then(res => {
      this.getList(1);
      this.toast_success(res.msg);
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  changeStatus(item: any,status:number) {
    this.http.changeStatus({id: item.id,status:status}).then(res => {
      this.getList(1);
      this.toast_success(res.msg);
    }).catch(res => {
      this.toast_warn(res.msg);
    });
  }

  openImg(src:string){
    window.open(src)
  }
}
